// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Unable to locate your property</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>We are unable to locate your property. Please contact your management company.</p>
            <div>Management ID: {{data.pmcId}}</div>
            <div>Association ID: {{data.hoaId}}</div>
            <div>Property / Account Number: {{data.propertyId}}</div>
            <div class="u-mB9 u-mT3">
                <a routerLink="/contact" [queryParams]="{pmcId: data.pmcId}"
                   target="_blank"
                   tid="contactLink" >
                    Contact {{data.pmcName || 'Management Company'}}
                </a>
            </div>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;